<div class="container-header">
    <ng-content select="[container-header]"></ng-content>
</div>
<div class="container-body">
    <ng-content select="[container-body]"></ng-content>
</div>